import React, { Component } from 'react';
import ExportSalesOrderComp from '../../../../components/sales/order/export';

export default class ExportSalesOrder extends Component {
	render() {
		return <ExportSalesOrderComp />;
	}
}
